import { GraphQLClient, gql } from 'graphql-request';

const API = process.env.NEXT_PUBLIC_SP4E_JCBW_API_URL ?? 'https://info.cld.hkjc.com/graphql/base/';
// const API = process.env.SITECORE_EDGE_GRAPH_URL ?? 'https://info.cld.qcew.com/graphql/base/';

const client = new GraphQLClient(API);

const QUERY = `
  query racing($date: String, $venueCode: String, $oddsTypes: [OddsType], $raceNo: Int) {
    raceMeetings(date: $date, venueCode: $venueCode) {
      pmPools(oddsTypes: $oddsTypes, raceNo: $raceNo) {
        id
        status
        sellStatus
        oddsType
        lastUpdateTime
        guarantee
        minTicketCost
        name_en
        name_ch
        leg {
          number
          races
        }
        cWinSelections {
          composite
          name_ch
          name_en
          starters
        }
        oddsNodes {
          combString
          oddsValue
          hotFavourite
          oddsDropValue
          bankerOdds {
            combString
            oddsValue
          }
        }
      }
    }
  }
`;

export async function GetOddsDataQuery(date: string, venueCode: string, raceNo: number) {
    try {
        const { raceMeetings } = await client.request(
            gql`
                ${QUERY}
            `,
            {
                date,
                venueCode,
                oddsTypes: ['WIN', 'PLA', 'QIN', 'QPL'],
                raceNo,
            }
        );
        return raceMeetings;
    } catch (error) {
        console.error('Error fetching news data:', error);
        throw error;
    }
}
